import { render, staticRenderFns } from "./cleanDetail.vue?vue&type=template&id=1ba35d94&"
import script from "./cleanDetail.vue?vue&type=script&lang=js&"
export * from "./cleanDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports